import {SignUpFormStateStore} from "./SignUpFormStateStore";
import {CoverageFormStore} from "./CoverageStore";
import { UpgradeFormStore } from "./UpgradeStore";
import {CancelPlanFormStore} from "./CancelPlanStore";
import { PartnersStore } from "./PartnersStore";
import { BrokersStore } from "./BrokersStore";
import {ShortSignupStore} from "./LendioStore";
import {BankConnectionStore} from "./BankConnectionStore";
import {SbaLoanStore} from "./SbaLoanStore";
import {ManageLoanStore} from "./ManageLoanStore";

export const formStores = {
    formStore: new SignUpFormStateStore(),
    coverageStore: new CoverageFormStore(),
    upgradeStore: new UpgradeFormStore(),
    partnersStore: new PartnersStore(),
    brokersStore: new BrokersStore(),
    cancelStore: new CancelPlanFormStore(),
    shortSignupStore: new ShortSignupStore(),
    connectBankStore: new BankConnectionStore(),
    sbaLoanStore: new SbaLoanStore(),
    manageLoanStore: new ManageLoanStore()
};



// WEBPACK FOOTER //
// ./src/scenes/Forms/state/mobx/index.ts